import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FooterService {
  public visibility: boolean = false;
  public saveFunction: () => void = () => {
  };

  public showFooter(saveFunction: () => boolean) {
    this.saveFunction = () => {
      var result = saveFunction();
      if (result) {
        this.hideFooter();
      }
    };
    this.visibility = true;
  }

  public hideFooter() {
    this.visibility = false;
    this.saveFunction = () => {
    };
  }
}
